import React from 'react'
import classes from './headphone.module.css'
import {NavLink} from 'react-router-dom'

const HeadPhone = ({setOpen, setOpenPhone}) => {
    const handlecontact = () =>{
        setOpen(true)
    }
  return (
      <nav className={classes.menu}>
        <ul className={classes.navigateur}>
        <li className={classes.list}><NavLink to="/" style={{color: '#2e80fb'}} className={classes.navTel} onClick={() => setOpenPhone(false)}>Home</NavLink></li>
        <li className={classes.list}><NavLink to="/blog" style={{color: '#2e80fb'}} className={classes.navTel} onClick={() => setOpenPhone(false)}>blog</NavLink></li>
        <li className={classes.contactMobile} onClick={handlecontact}>contact</li>
        </ul>
      </nav>
  )
}

export default HeadPhone
